import {
  ApiEmployeeColumn,
  ApiEmployeeColumnFilter,
  ApiEmployeeColumnFilterType,
} from "@/types/employees/employee-column.types.ts";

/** Значение фильтра без ключа колонки: его меняют контролы панели. */
export type ColumnFilterValue = Omit<ApiEmployeeColumnFilter, "field">;

/**
 * Условие фильтра. `value` — сравнение со значением своего типа (подстрока,
 * диапазон, период, любой из), `empty` / `filled` — `is_empty` (бэк принимает
 * его у колонки любого типа), `yes` / `no` — `switch` у bool-колонки.
 */
export enum EmployeeColumnFilterCondition {
  value = "value",
  empty = "empty",
  filled = "filled",
  yes = "yes",
  no = "no",
}

const VALUE_CONDITIONS = [EmployeeColumnFilterCondition.value];

// bool хранит «нет» как false: «заполнено» у него — это «да или нет», такой выбор не нужен
const BOOL_CONDITIONS = [EmployeeColumnFilterCondition.yes, EmployeeColumnFilterCondition.no];

/** Условия, доступные колонке по `filter_type` каталога. */
export function getColumnFilterConditions(
  filterType: ApiEmployeeColumnFilterType
): EmployeeColumnFilterCondition[] {
  switch (filterType) {
    case ApiEmployeeColumnFilterType.bool:
      return BOOL_CONDITIONS;
    case ApiEmployeeColumnFilterType.none:
      return [];
    default:
      return VALUE_CONDITIONS;
  }
}

/**
 * Текущее условие фильтра. `undefined` — условие ещё не выбрано: так бывает
 * только у bool-колонки, у которой нет условия со значением.
 */
export function getColumnFilterCondition(
  column: ApiEmployeeColumn,
  filter: ApiEmployeeColumnFilter
): EmployeeColumnFilterCondition | undefined {
  if (filter.is_empty === true) return EmployeeColumnFilterCondition.empty;
  if (filter.is_empty === false) return EmployeeColumnFilterCondition.filled;
  if (column.filter_type === ApiEmployeeColumnFilterType.bool) {
    if (filter.switch === true) return EmployeeColumnFilterCondition.yes;
    if (filter.switch === false) return EmployeeColumnFilterCondition.no;
    return undefined;
  }
  return EmployeeColumnFilterCondition.value;
}

/**
 * Значение фильтра после выбора условия. Значение прежнего условия не
 * переносится: «пусто» с непустым значением бэк соединит через AND и не найдёт
 * никого.
 */
export function applyColumnFilterCondition(
  condition: EmployeeColumnFilterCondition
): ColumnFilterValue {
  switch (condition) {
    case EmployeeColumnFilterCondition.empty:
      return { is_empty: true };
    case EmployeeColumnFilterCondition.filled:
      return { is_empty: false };
    case EmployeeColumnFilterCondition.yes:
      return { switch: true };
    case EmployeeColumnFilterCondition.no:
      return { switch: false };
    case EmployeeColumnFilterCondition.value:
      return {};
  }
}
